'use strict'

window.ReportWorklistSharedFunctions = {
    table: null,
    uniquePrefix: null,
    worklistID: null,
    reportId: null,
    registerRoomFilterClickListeners: () => {
        $('.visibleRooms input.checkRoomVis').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var visible = $(this).prop('checked');

            if (visible) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            }
            else {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            }
        });

        $('.visibleRooms span#selectAllRooms').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.visibleRooms input.checkRoomVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });
        });

        $('.visibleRooms span#deselectAllRooms').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.visibleRooms input.checkRoomVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });
        });

        $('.visibleRooms span.selectAllRoomsFromSite').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var parentContainer = $(this).parent().parent();
            $(parentContainer).find('.checkRoomVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });
        });

        $('.visibleRooms span.deselectAllRoomsFromSite').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var parentContainer = $(this).parent().parent();
            $(parentContainer).find('.checkRoomVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });
        });

        $('#filterRooms').on('click', function () {
            OrderReportWorklistShared.checkAndSetRoomFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
            $('div#content').trigger("click");
        });
    },
    registerAuthorSupervisorFilterClickListeners: () => {
        $('input.checkAuthorSupervisorVis').on('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            var visible = $(this).prop('checked');
            if (visible) {
                $(this).attr('checked', 'checked');
            }
            else {
                $(this).removeAttr('checked');
            }
            ReportWorklistSharedFunctions.checkAndSetAuthorSupervisorFilterActive();
            ReportWorklistSharedFunctions.refreshTable();
        });

        $('.setAuthorSupervisor span#selectAllAuthorSupervisor').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setAuthorSupervisor input.checkAuthorSupervisorVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });
            ReportWorklistSharedFunctions.checkAndSetAuthorSupervisorFilterActive();
            ReportWorklistSharedFunctions.refreshTable();
        });

        $('.setAuthorSupervisor span#deselectAllAuthorSupervisor').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setAuthorSupervisor input.checkAuthorSupervisorVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });
            ReportWorklistSharedFunctions.checkAndSetAuthorSupervisorFilterActive();
            ReportWorklistSharedFunctions.refreshTable();
        });
    },
    registerModalityFilterClickListeners: () => {
        $('input.checkModalityVis').on('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            var visible = $(this).prop('checked');
            if (visible) {
                $(this).attr('checked', 'checked');
            }
            else {
                $(this).removeAttr('checked');
            }
            ReportWorklistSharedFunctions.checkAndSetModalityFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleModalities span#selectAllModalities').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleModalities input.checkModalityVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });

            ReportWorklistSharedFunctions.checkAndSetModalityFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleModalities span#deselectAllModalities').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleModalities input.checkModalityVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });

            ReportWorklistSharedFunctions.checkAndSetModalityFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });
    },
    registerLabelFilterClickListeners: () => {
        $('input.checkLabelVis').on('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            var visible = $(this).prop('checked');
            if (visible) {
                $(this).attr('checked', 'checked');
            }
            else {
                $(this).removeAttr('checked');
            }
            ReportWorklistSharedFunctions.checkAndSetLabelFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleLabels span#selectAllLabels').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleLabels input.checkLabelVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });
            ReportWorklistSharedFunctions.checkAndSetLabelFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleLabels span#deselectAllLabels').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleLabels input.checkLabelVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });
            ReportWorklistSharedFunctions.checkAndSetLabelFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });
    },
    registerSpecialismFilterClickListeners: () => {
        $('input.checkSpecialismVis').on('click', function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            var visible = $(this).prop('checked');
            if (visible) {
                $(this).attr('checked', 'checked');
            }
            else {
                $(this).removeAttr('checked');
            }
            ReportWorklistSharedFunctions.checkAndSetSpecialismFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleSpecialisms span#selectAllSpecialisms').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleSpecialisms input.checkSpecialismVis:not(:checked)').each(function (e) {
                $(this).attr('checked', 'checked');
                $(this).prop('checked', true);
            });
            ReportWorklistSharedFunctions.checkAndSetSpecialismFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });

        $('.setVisibleSpecialisms span#deselectAllSpecialisms').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('.setVisibleSpecialisms input.checkSpecialismVis:checked').each(function (e) {
                $(this).removeAttr('checked');
                $(this).prop('checked', false);
            });
            ReportWorklistSharedFunctions.checkAndSetSpecialismFilterActive();
            ReportWorklistSharedFunctions.refreshTable(true);
        });
    },
    checkAndSetAuthorSupervisorFilterActive: () => {
        const authorSupervisorDefault = true;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".setAuthorSupervisor", ".checkAuthorSupervisorVis", authorSupervisorDefault);
    },
    checkAndSetLabelFilterActive: () => {
        const labelFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".dataTables_filter .setVisibleLabels", ".checkLabelVis", labelFilterDefault);
    },
    checkAndSetModalityFilterActive: () => {
        const modalityFilterDefault = true;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".dataTables_filter .setVisibleModalities", ".checkModalityVis", modalityFilterDefault);
    },
    checkAndSetSpecialismFilterActive: () => {
        const specialismFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".dataTables_filter .setVisibleSpecialisms", ".checkSpecialismVis", specialismFilterDefault);
    },
    refreshTable: (updatedFilter) => {
        filter = $(".dataTables_filter > label:first-of-type input:first-of-type").val();

        if (updatedFilter) {
            ReportWorklistSharedFunctions.saveFilterPreferences();
        }

        ReportWorklistSharedFunctions.table.fnFilter(filter);
        $('span#refreshTime').text(moment().format("HH:mm:ss"));
    },
    saveFilterPreferences: () => {
        const pageCount = $(".dataTables_length select :selected").text();
        const labelFilters = $('.dataTables_filter .setVisibleLabels').length
            ? Array.from($(".dataTables_filter .checkLabelVis").map((i,e) => e)).reduce((acc, e) => { return {...acc, [e.getAttribute("data-dbID")]:e.checked}} , {})
            : null;
        const modalityFilters = $('.dataTables_filter .setVisibleModalities').length
            ? Array.from($(".dataTables_filter .checkModalityVis").map((i,e) => e)).reduce((acc, e) => { return {...acc, [e.getAttribute("data-dbID")]:e.checked}} , {})
            : null;
        const roomFilters = $('.setVisibleRooms').length
            ? Array.from($(".checkRoomVis").map((i,e) => e)).reduce((acc, e) => { return {...acc, [e.getAttribute("value")]:e.checked}} , {})
            : null;
        const specialityFilters = $('.dataTables_filter .setVisibleSpecialisms').length
            ? Array.from($(".dataTables_filter .checkSpecialismVis").map((i,e) => e)).reduce((acc, e) => { return {...acc, [e.getAttribute("data-dbID")]:e.checked}} , {})
            : null;
        fetch(`/api/user/preferences/reportworklist`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Worklist: ReportWorklistSharedFunctions.worklistID,
                LabelFilterOptions: labelFilters,
                ModalityFilterOptions: modalityFilters,
                RoomFilterOptions: roomFilters,
                SpecialityFilterOptions: specialityFilters,
                PageCount: pageCount
            })
        });
    },
    ShowPopupChooseSupervisor: (id) => {
        ReportWorklistSharedFunctions.reportId = id;

        $.ajax({
            type: "GET",
            url: "/legacy/Session/GetLastChosenSupervisors",
            async: false,
            success: function (data) {
                if (data.Supervisors.length > 0) {
                    $('#previousChosenSupervisors li.previousChosenSupervisor').remove();
                    for (var i = data.Supervisors.length - 1 ; i >= 0 ; i--) {
                        var li = '<li class="previousChosenSupervisor">- ' + data.Supervisors[i].Name + '<input type="hidden" class="previousChosenSupervisorID" value="' + data.Supervisors[i].ID + '" /></li>';
                        $('#previousChosenSupervisors').append(li);
                    }
                    $('#noPreviousChosenSupervisors').hide();
                }
                else {
                    $('#noPreviousChosenSupervisors').show();
                }
            }
        });

        $('#popupNewChoosenSupervisorID').val("");

        $('#btnChooseSupervisor').attr('disabled', true);

        $('#divChooseSupervisor').dialog('open');
    },
    addChosenSupervisorToSession: (selectedSupervisorID) => {
        $.ajax({
            type: "POST",
            url: "/legacy/Session/AddChosenSupervisorToSession",
            async: false,
            data: {
                Supervisor_UID: selectedSupervisorID
            },
            success: function(data) {

            }
        });
    },
    // For supervisor changing
    registerToValidateClickListeners: () => {
        $('#btnChooseSupervisor').on('click', function(e) {
            var newSupervisorID = $('#popupNewChoosenSupervisorID').val();
            var oldSupervisorID;
            var selectedSupervisorID;

            if (newSupervisorID) {
                selectedSupervisorID = newSupervisorID;
            } else {
                oldSupervisorID = $('.previousChosenSupervisor.active').find('.previousChosenSupervisorID').val();
                if (oldSupervisorID) {
                    selectedSupervisorID = oldSupervisorID;
                }
            }

            if (selectedSupervisorID) {
                $.ajax({
                    type: "POST",
                    url: "/legacy/Reports/ChangeSupervisor",
                    async: false,
                    data: {
                        ReportId: ReportWorklistSharedFunctions.reportId,
                        supervisorId: selectedSupervisorID,
                    },
                    success: function(data) {
                        $("#popupChooseSupervisor").val("");
                        $('#divChooseSupervisor').dialog('close');
                        ReportWorklistSharedFunctions.addChosenSupervisorToSession(selectedSupervisorID);
                        ReportWorklistSharedFunctions.refreshTable();
                    }
                });
            }
        });

        // Select previous chosen supervisors
        $('body').on('click', 'li.previousChosenSupervisor', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('li.previousChosenSupervisor').removeClass('active');
            $(this).addClass('active');
            $('#popupChooseSupervisor').val("");
            $('#popupNewChoosenSupervisorID').val("");
            $('#btnChooseSupervisor').prop('disabled', false);
        });
    },
    validateReport: (Order_UID, Report_UID, OrderProcedure_UIDs, isProcedureCombination, closeAfter) => {
        function releaseLock(lockUIDs) {
            if (!lockUIDs) return;

            $.ajax({
                type: 'POST',
                url: '/legacy/Locks/ReleaseLocks',
                data: { LockUIDs: lockUIDs, isCloseAll: false },
            });
        }
        function validate(Order_UID, Report_UID, closeAfter, lockUIDs) {
            const urlPart = isProcedureCombination === true ? 'ValidateReportCombinationInBulk' : 'ValidateReportInBulk';
            $.ajax({
                type: "GET",
                url: `/legacy/Reports/${urlPart}`,
                async: false,
                data: {
                    Order_UID: Order_UID,
                    Report_UID: Report_UID
                },
                success: function (data) {
                    if (!data.AllOk) {
                        console.error("Could not Validate");
                    }
                    if (closeAfter && closeAfter === true) {
                        closeActiveFile(true, true);
                    }
                    else {
                        releaseLock(lockUIDs);
                    }
                    if (data.PrintFail == true) {
                        $('#divPrintFailDialog p#printMessage').html(data.Message);
                        $('#divPrintFailDialog').dialog('open');
                    }
                },
                error: function () {
                   releaseLock(lockUIDs); 
                }
            });
        }
        

        $.ajax({
            type: 'POST',
            url: '/legacy/Locks/TryCreateLockFile',
            data: {
                LockType: isProcedureCombination ? LockType.Report : LockType.OrderReport,
                RecordID: isProcedureCombination ? OrderProcedure_UIDs : Order_UID
            },
            async: false,
            dataType: 'json',
            success: function (data) {
                if (data.Done) {
                    validate(Order_UID, Report_UID, closeAfter, data.LockUIDs);
                } else if (!data.Done) {
                    window.showLockedFileDialog(data, null, validate.bind(this, Order_UID, Report_UID));
                }
            }
        });
    }
}
